export default __webpack_public_path__ + "static/media/MetrixLogoGrey.823f3f10.png";